import React, { Component } from 'react';
import './Press.css';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import fileicon from '../static/icons/fileicon.svg';
import white_frame from '../static/icons/whiteframe.svg';

class ImageIcon extends Component {
  render() {
    return (
      <div className="imgdiv" key={this.props.pic.id}>
        <a
          download={this.props.pic.file_name+".jpg"}
          href={this.props.pic.tinyurl}
          title={this.props.pic.file_name}
          target="_blank"
        >
          <div className="imageDiv" >
            <img alt={this.props.pic.file_name} className="whiteframe" src={white_frame}/>
            <img alt={this.props.pic.file_name} className="thumb" src={this.props.pic.image.thumb} />
          </div>
          <p className="filename">{this.props.pic.file_name}</p>
        </a>
      </div>
    );
  }
}

class DocumentIcon extends Component {
  render() {
    return (
      <div className="imgdiv" key={this.props.doc.id}>
        <a
          download={this.props.doc.file_name}
          href={this.props.doc.tinyurl}
          title={this.props.doc.file_name}
        >
          <div className="imageDiv" >
            <img alt={this.props.doc.file_name} className="fileicon" src={fileicon}/>
          </div>
          <p className="filename" >{this.props.doc.file_name}</p>
        </a>
      </div>
    );
  }
}

class Press extends Component {
  constructor(props) {
    super(props);
    this.state = {images: [], documents: []};
    this.update = this.update.bind(this);
  }

  update(){
    const imgs = this.props.imgs.map(obj => <ImageIcon key={obj.id} pic={obj}/>)
    const docs = this.props.docs.map(obj => <DocumentIcon key={obj.id} doc={obj}/>)
    this.setState( { images:imgs, documents:docs });
  }
  componentDidUpdate(prevProps){
    if (prevProps !== this.props) {
      this.update()
    }
  }
  componentDidMount(){
    this.update()
  }
  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <p className="head">press</p>
          </Col>
        </Row>
        <Row className="files">
          <Col md={12}>
          {this.state.images}
          {this.state.documents}
          </Col>
        </Row>
      </div>
    );
  }
}

export default Press;



// WEBPACK FOOTER //
// ./src/artist/Press.js